export enum OrderOptimizerRailyListingItemStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

export type OrderOptimizerRailyListingItemOrder = {
  humanId: number;
  startTime: Date;
  cargoCompany: string;
  taxiCorporation: string;
  haltingTimeBefore: number;
};

export type OrderOptimizerRailyListingItemRoute = {
  orderHumanId: number;
  lat: number;
  lon: number;
};

export type OrderOptimizerRailyListingItem = {
  id: string;
  score: number;
  status: OrderOptimizerRailyListingItemStatus;
  route: OrderOptimizerRailyListingItemRoute[];
  orders: OrderOptimizerRailyListingItemOrder[];
  reviewedBy: string | null;
  reviewedAt: Date | null;
};

type OrderOptimizerRailyListing = {
  data: OrderOptimizerRailyListingItem[];
  totalCount: number;
};

export default OrderOptimizerRailyListing;
